<template>
  <div ref="charts" style="width:100%;height:600px"></div>
</template>
<script>
import echarts from "echarts";
import { onMounted, ref } from "vue";
import { useChinaMap } from "@/hooks/useChinaMap.js";
export default {
  props:{mapData:Array},
  setup(props) {
    const mapStack = ref([{ id: "100000", name: "china" }]);
    // 地图 echartData
    const charts = ref(null);
    const { setMap, initMap } = useChinaMap();
    const handleMap = (data) => {
      setMap(mapStack.value[mapStack.value.length - 1], data);
    };
    const initData = () => {
     handleMap(
      props.mapData.map((v) => {
          v["total"] = v.value;
          return v;
        })
      );
    };
    onMounted(() => {
      initData();
      initMap(charts.value);
    });
    return {
      charts,
    };
  },
};
</script>